import React from 'react';

import ReactApexChart from 'react-apexcharts';
import SvgList from '../SvgList';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const options = (graphFilter) => {
  let categories = [];

  // { value: 'DAILY', label: 'Daily' },
  // { value: 'WEEKLY', label: 'Weekly' },
  // { value: 'MONTHLY', label: 'Monthly' },
  // { value: 'HALF_YEARLY', label: 'Half Yearly' },
  // { value: 'START_YEAR', label: 'Start Year' },
  // { value: 'YEARLY', label: 'Yearly' },

  if (graphFilter === 'YEARLY') categories = months;
  else if (graphFilter === 'START_YEAR') categories = months.slice(0, new Date().getMonth() + 1);
  else if (graphFilter === 'HALF_YEARLY') {
    if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
    else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  } else if (graphFilter === 'MONTHLY') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  else if (graphFilter === 'WEEKLY') categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  else categories = Array.from({ length: 24 }, (_, i) => i);

  // if (graphFilter === 'This Year') categories = months;
  // else if (graphFilter === 'This 6 Months') {
  //   if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
  //   else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  // } else if (graphFilter === 'This Month') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  // else if (graphFilter === 'Last 7 days')
  //   categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  // else categories = months;

  return {
    legend: {
      show: false,
    },
    chart: {
      // type: 'bar',
      type: 'area',
      // height: 200,
      id: 'apexchart-example',

      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
      // hideOverflowingLabels: false,
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },

    // colors: ['red', 'yellow' ],

    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ['transparent'],
    // },
    // stroke: {
    //   curve: 'smooth',
    //   width: 3,
    //   colors: ['#0067FB'],
    // },
    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['rgba(0, 103, 251, 0.6)'], // Using RGBA for semi-transparent blue
    },

    // fill: {
    //   type: 'gradient',
    //   gradient: {
    //     shadeIntensity: 1,
    //     opacityFrom: 0.7,
    //     opacityTo: 0.3,
    //     // define multiple stops
    //     stops: [0, 90, 100],
    //     colorStops: [],
    //   },
    // },
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical', // The gradient should be vertical, assuming the lighter color is at the bottom
        shadeIntensity: 1, // Intensity of the shade color
        opacityFrom: 0.7, // Full opacity at the start of the gradient
        opacityTo: 0.0, // Completely transparent at the end of the gradient
        stops: [0, 20, 40, 60, 80, 100], // More stops give a smoother gradient
        colorStops: [
          {
            offset: 0,
            color: '#0067FB',
            opacity: 0.09,
          },
          {
            offset: 20,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 40,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 60,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 80,
            color: '#0067FB',
            opacity: 0,
          },
          {
            offset: 100,
            color: '#0067FB',
            opacity: 0,
          },
        ],
      },
    },

    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
      axisTicks: {
        show: false,
      },

      tickAmount: 12,

      labels: {
        show: true,
        style: {
          // colors: [
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          //   '#71717A',
          // ],
          fontSize: '13px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },
      },
    },

    yaxis: {
      tickAmount: 12,
      labels: {
        show: false,
        style: {
          colors: ['#71717A'],
          fontSize: '12px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },

        // formatter: function (val: string) {
        //   return numberWithCommas(parseInt(val));
        // },
      },
    },

    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val + 'K';
        },
      },
    },
  };
};

const options2 = (graphFilter) => {
  let categories = [];

  if (graphFilter === 'YEARLY') categories = months;
  else if (graphFilter === 'START_YEAR') categories = months.slice(0, new Date().getMonth() + 1);
  else if (graphFilter === 'HALF_YEARLY') {
    if (new Date().getMonth() <= 5) categories = months.slice(0, 6);
    else categories = months.slice(new Date().getMonth() - 5, new Date().getMonth() + 1);
  } else if (graphFilter === 'MONTHLY') categories = Array.from({ length: 31 }, (_, i) => i + 1);
  else if (graphFilter === 'WEEKLY') categories = Array.from({ length: 7 }, (_, i) => weekdays[i]);
  else categories = Array.from({ length: 24 }, (_, i) => i);

  return {
    legend: {
      show: false,
    },
    chart: {
      // type: 'bar',
      type: 'area',
      // height: 200,
      id: 'apexchart-example',

      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
      // hideOverflowingLabels: false,
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },

    stroke: {
      curve: 'smooth',
      width: 3,
      colors: ['#00ab47'],
      opacity: 0.6,
      // Using RGBA for semi-transparent blue
    },

    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical', // The gradient should be vertical, assuming the lighter color is at the bottom
        shadeIntensity: 1, // Intensity of the shade color
        opacityFrom: 0.7, // Full opacity at the start of the gradient
        opacityTo: 0.0, // Completely transparent at the end of the gradient
        stops: [0, 20, 40, 60, 80, 100], // More stops give a smoother gradient
        colorStops: [
          {
            offset: 0,
            color: '##00ab47',
            opacity: 0.09,
          },
          {
            offset: 20,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 40,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 60,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 80,
            color: '##00ab47',
            opacity: 0,
          },
          {
            offset: 100,
            color: '##00ab47',
            opacity: 0,
          },
        ],
      },
    },

    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
      axisTicks: {
        show: false,
      },

      tickAmount: 12,

      labels: {
        show: true,
        style: {
          colors: ['#00ab47'],
          fontSize: '13px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },
      },
    },

    yaxis: {
      tickAmount: 12,
      labels: {
        show: false,
        style: {
          colors: ['#00ab47'],
          fontSize: '12px',
          paddingRight: 15,
          paddingLeft: 15,
          fontFamily: 'Plus Jakarta Sans, Arial, sans-serif',
          fontWeight: 500,
          lineHeight: 20,
        },

        // formatter: function (val: string) {
        //   return numberWithCommas(parseInt(val));
        // },
      },
    },

    markers: {
      size: 0,
      colors: ['#00ab47'], // Green color for the marker dot
      strokeColors: '#ffffff',
      strokeWidth: 2,
      show: false,
      hover: {
        size: 5, // The size of the marker when hovered
        sizeOffset: 3, // You can adjust this value if you want the marker to increase in size when hovered
      },
    },

    tooltip: {
      theme: 'light', // Choose between 'light' or 'dark'
      x: {
        show: false,
      },
      y: {
        formatter: function (val) {
          return '$ ' + val.toFixed(2);
        },
      },
      markers: {
        show: false,
      },
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const val = series[seriesIndex][dataPointIndex];
        console.log('val', dataPointIndex);
        return (
          '<div class="apexcharts-tooltip-title" style="font-weight: 600; color: #00ab47;">' +
          categories[dataPointIndex] +
          '</div><div class="apexcharts-tooltip-series-group" style="display: flex; align-items: center;">' +
          '<span class="apexcharts-tooltip-marker" style="background-color: #00ab47;"></span>' + // Green bullet point
          '<div class="apexcharts-tooltip-text" style="background-color: #f4f4f4; padding: 4px; border-radius: 2px;">' +
          '<span style="font-size: 12px; color: #333;">Total Log: $' +
          [val.toFixed(2)] +
          '</span>' +
          '</div></div>'
        );
      },
      fixed: {
        enabled: false,
      },
    },
  };
};

// ... React component returns ApexChart with these options ...

const NoDataMessage = () => (
  <div
    className="no-data"
    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}
  >
    <SvgList name="no-data-icon" />
    <p style={{ marginTop: '8px' }}>No Data to show.</p>
  </div>
);

const Graph = ({ data, graphFilter, type }) => {
  const graphData = data;
  const dates = graphData.map((item) => item.date);


  const totalLogs = type === 'View' ? graphData.map((item) => item.total_logs) : graphData.map((item) => item.total_logs * 0.003);

  const chartData = {
    series: [
      {
        name: 'Total Log',
        data: totalLogs, // from the prepared data
      },
    ],
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {data.length > 0 ? (
        <ReactApexChart
          type={'area'}
          options={type === 'View' ? options(graphFilter) : options2(graphFilter)}
          series={chartData.series}
          height={306}
          width={'100%'}
        />
      ) : (
        <NoDataMessage />
      )}
    </div>
  );
};

export default Graph;
